export default __webpack_public_path__ + "static/media/DSC_0026.6cea11e1.jpg";